import { createAsyncAction } from 'typesafe-actions';
import { IUserTenantInfo } from '../../models/masterdata/ITenant';

export const setActiveTenant = createAsyncAction('setactivetenant/fetch_request', 'setactivetenant/fetch_success', 'setactivetenant/fetch_failure')<IUserTenantInfo, IUserTenantInfo, Error>();
